import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CheckIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M6.0001 10.78L3.2201 8.00002L2.27344 8.94002L6.0001 12.6667L14.0001 4.66668L13.0601 3.72668L6.0001 10.78Z" />
  </Icon>
);

export default memo(CheckIcon);
